/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyNotionIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-notion" */ './utils').then((m) => m.NotionIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/icon' },
);

const LazyNotionSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-notion-search-result" */ './utils').then(
			(m) => m.NotionSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon' },
);

const LazyNotionIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-notion-borderless" */ './utils').then(
			(m) => m.NotionIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const NotionIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyNotionIconComponent />
	</Suspense>
);

export const NotionSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyNotionSearchResultIconComponent />
	</Suspense>
);

export const NotionIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyNotionIconBorderlessComponent />
	</Suspense>
);
